import angular from 'angular';

import searchLookupUrl from './searchLookup.html';

export default function searchLookup($document, $parse, $timeout, $window, $q) {
  'ngInject';

  return {
    scope: true,
    restrict: 'E',
    replace: true,
    transclude: true,
    require: 'ngModel',
    templateUrl: searchLookupUrl,
    link($scope, $element, $attrs, $ngModel, $transcludeFn) {
      const results = $element.children().eq(1);
      $transcludeFn($scope, (clone) => {
        results.append(clone);
      });

      $attrs.$observe('placeholder', (value) => {
        $scope.placeholder = value;
      });

      $attrs.$observe('focusOnId', (value) => {
        $scope.focusOnId = value;
      });

      $scope.inputDisabled = false;
      $attrs.$observe('disabled', (val) => {
        $scope.inputDisabled = Boolean(val);
      });

      const search = {};
      $scope.$search = search;

      if ('searchObject' in $attrs) {
        const parsedSearchBinding = $parse($attrs.searchObject);
        if (parsedSearchBinding.assign) {
          parsedSearchBinding.assign($scope, search);
        }
      }

      $scope.hideGlassIcon = Boolean($attrs.hideGlassIcon && $parse($attrs.hideGlassIcon)($scope));
      search.activeIndex = 0;

      $scope.$watch('$search.items.length', (len) => {
        if (search.activeIndex >= len) {
          search.activeIndex = len - 1;
        }

        if (search.activeIndex < 0 && len > 0) {
          search.activeIndex = 0;
        }
      });

      $scope.$watch(
        () => $ngModel.$viewValue,
        (val) => {
          $scope.model = val;
        }
      );

      $scope.$watch('model', (value) => {
        $ngModel.$setViewValue(value);
      });

      $scope.glassClicked = function glassClicked() {
        $element.children()[0].focus();
      };

      const onClick = $parse($attrs.onItemClick);
      const basePadding = Number(getComputedStyle($element.children()[0]).paddingLeft.slice(0, -2));

      function adjustScroll() {
        const activeItem = results[0].querySelector('.search-lookup .search-lookup-item.active');
        const activeItemRect = activeItem.getBoundingClientRect();
        const resultsRect = results[0].getBoundingClientRect();

        if (activeItemRect.bottom - resultsRect.bottom > 0) {
          results[0].scrollTop += activeItemRect.bottom - resultsRect.bottom;
        }

        if (activeItemRect.top - resultsRect.top < 0) {
          results[0].scrollTop += activeItemRect.top - resultsRect.top;
        }
      }

      function canEnter() {
        return (
          search.items.length && search.activeIndex >= 0 && search.activeIndex < search.items.length
        );
      }

      function handleKeyCode(e) {
        switch (e.keyCode) {
          case 40: // arrow down
            $scope.$apply(() => {
              search.activeIndex = Math.min(search.activeIndex + 1, search.items.length - 1);
              $timeout(adjustScroll, 0, false);
            });
            e.preventDefault();
            return false;

          case 38: // arrow up
            $scope.$apply(() => {
              search.activeIndex = Math.max(search.activeIndex - 1, 0);
              $timeout(adjustScroll, 0, false);
            });
            e.preventDefault();
            return false;

          case 13: // enter
            if (canEnter()) {
              $scope.$apply(() => {
                search.activeItem = search.items[search.activeIndex];
                const promise = onClick($scope);
                (promise || $q.resolve()).then(() => {
                  if (!('noClearOnEnter' in $attrs)) {
                    $scope.model = '';
                  }

                  $scope.$evalAsync(() => {
                    $scope.closeLookup();
                  });
                });
              });
            }
            e.stopPropagation();
            e.preventDefault();
            return false;

          case 27: // esc
            $scope.$apply(() => {
              $scope.closeLookup();
            });

            angular.element(e.currentTarget)[0].blur();
            e.stopPropagation();
            return false;

          case 8: // backspace
            if (!$scope.model && onEmptyBackspace) {
              $scope.$apply(onEmptyBackspace);
              return false;
            }

            break;
          default:
        }
      }

      let onEmptyBackspace;

      if ('onEmptyBackspace' in $attrs) {
        onEmptyBackspace = $parse($attrs.onEmptyBackspace).bind(null, $scope.$parent);
      }

      const lookupInput = $element.children().eq(0);
      lookupInput.on('keydown', (e) => {
        if (!$scope.opened) {
          $scope.$evalAsync(() => {
            $scope.openLookup();
          });

          e.stopPropagation();
          if (e.keyCode === 13) {
            e.preventDefault();
          }

          return true;
        }

        handleKeyCode(e);
      });

      $scope.openLookup = function openLookup() {
        $scope.opened = true;
        if (!$scope.hideGlassIcon) {
          // persona-picker handles icon change with css
          const padding = basePadding - 28;
          lookupInput.css('padding-left', `${padding}px`);
        }
        $scope.$emit('search-lookup-open');
      };

      $scope.closeLookup = function closeLookup() {
        $scope.opened = false;
        if (!$scope.hideGlassIcon) {
          lookupInput.css('padding-left', `${basePadding}px`);
        }
        $scope.$emit('search-lookup-close');
      };

      function handler(e) {
        if ('button' in e && e.button !== 0) {
          return;
        }

        if (e.type === 'focusin' && !/^(input|textarea)$/i.test(e.target.tagName)) {
          return;
        }

        if (angular.element(e.target).closest($element).length) {
          $scope.$evalAsync(() => {
            if (!$scope.opened) {
              $scope.openLookup();
            }
          });
        } else {
          $scope.$evalAsync(() => {
            if ($scope.opened) {
              $scope.closeLookup();
            }
          });
        }
      }

      $window.addEventListener('focusin', handler);
      $document.on('mousedown', handler);

      $element.on('click', (e) => {
        if (angular.element(e.target).closest('.search-lookup-item').length && $scope.opened) {
          $scope.$evalAsync(() => {
            $scope.closeLookup();
          });
        }
      });

      $scope.$on('$destroy', () => {
        $document.off('mousedown', handler);
        $window.removeEventListener('focusin', handler);
      });
    },
  };
}
